import { createStore } from 'vuex'

// Estado padrão (caso não exista nada no localStorage)
function getDefaultState() {
  return {
    isUserLoggedIn: false,
    logTime: null,
    token: null,
    user: null,
    snackbar: { visible: false, color: null, text: '' }
  }
}

// Carregar estado do localStorage
function loadState() {
  try {
    const state = localStorage.getItem('store')
    return state ? JSON.parse(state) : getDefaultState()
  } catch (error) {
    console.error('Erro ao carregar o estado do localStorage:', error)
    return getDefaultState()
  }
}

// Guardar estado no localStorage
function saveState(state) {
  try {
    localStorage.setItem('store', JSON.stringify(state))
  } catch (error) {
    console.error('Erro ao salvar o estado no localStorage:', error)
  }
}

const store = createStore({
  state: loadState(),
  mutations: {
    setIsUserLoggedIn(state, value) {
      state.isUserLoggedIn = value
    },
    setLogTime(state, value) {
      state.logTime = value
    },
    setToken(state, value) {
      state.token = value
    },
    setUser(state, value) {
      state.user = value
    },
    setSnackbar(state, value) {
      state.snackbar.visible = true
      state.snackbar.color = value.color
      state.snackbar.text = value.text
    },
    setSnackbarHide(state) {
      state.snackbar.visible = false
    },
    resetState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setIsUserLoggedIn({ commit }, value) {
      commit('setIsUserLoggedIn', value)
    },
    setLogTime({ commit }, value) {
      commit('setLogTime', value)
    },
    setToken({ commit }, value) {
      commit('setToken', value)
    },
    setUser({ commit }, value) {
      commit('setUser', value)
    },
    setSnackbar({ commit }, value) {
      commit('setSnackbar', value)
      setTimeout(() => {
        commit('setSnackbarHide')
      }, value.timeout || 3000)
    },
    resetStore({ commit }) {
      commit('resetState')
      localStorage.removeItem('store')
    }
  },
})

store.subscribe((mutation, state) => {
  saveState(state)
})

export default store